const quizQuestions = [
  {
      question: "When you eat a pizza, do you prefere :",
      answers: [
          {
              type: "Pos",
              content: "Tomato based"
          },
          {
              type: "Neg",
              content: "Cream based"
          },
          {
            type: "Positive",
            content: "I hate pizza"
        },
        {
            type: "Negative",
            content: "Nutella base"
        }
      ]
  },
  {
      question: "What is you favorite animal ?",
      answers: [
          {
              type: "Neg",
              content: "Giraffe"
          },
          {
              type: "Pos",
              content: "Beaver"
          },
          {
              type: "Positive",
              content: "Pengiun"
          },
          {
              type: "Negative",
              content: "Kangaroo"
          }
      ]
  },
  {
      question: "Where do you see yourself in a few weeks ?",
      answers: [
          {
              type: "Pos",
              content: "Rome"
          },
          {
              type: "Positive",
              content: "Bora Bora"
          },
          {
              type: "Neg",
              content: "Home, obviously"
          },
          {
              type: "Negative",
              content: "Six feet under"
          }
      ]
  },
  {
      question: "How do you want to work :",
      answers: [
          {
              type: "Pos",
              content: "In a cool start-up"
          },
          {
              type: "Neg",
              content: "In a big international company"
          },
          {
              type: "Positive",
              content: "As a nomad digital"
          },
          {
              type: "Negative",
              content: "To what ?"
          }
      ]
  },
  {
      question: "What kind of sport do you like ?",
      answers: [
          {
              type: "Pos",
              content: "Indoors sports"
          },
          {
              type: "Neg",
              content: "Outdoors sports"
          },
          {
              type: "Positive",
              content: "In bed sports"
          },
          {
              type: "Negative",
              content: "None"
          }
      ]
  },
  {
      question: "What is you favorite cocktail ?",
      answers: [
          {
              type: "Pos",
              content: "Caipirinha"
          },
          {
              type: "Neg",
              content: "Dry martini"
          },
          {
              type: "Positive",
              content: "Bloody mary"
          },
          {
              type: "Negative",
              content: "Virgin Pina Colada"
          }
      ]
  },
  {
      question: "What is you favorite element ?",
      answers: [
          {
              type: "Pos",
              content: "Earth"
          },
          {
              type: "Neg",
              content: "Fire"
          },
          {
              type: "Positive",
              content: "Water"
          },
          {
              type: "Negative",
              content: "Air"
          }
      ]
  }
];

export default quizQuestions;